<template>
  <div class="w-full col-span-full">
    <info-bulle :libelle="labelLibelle" :name="name" :is-libelle-input="true">
      <template #libelleBefore>
        <p
          :for="name"
          v-html="libelle"
          class="text-sm text-gray-600 font-normal truncate mb-2"
          :style="
            inherits != undefined && inherits != null && inherits
              ? 'color: inherit; font-size: inherit; font-weight: inherit;'
              : ''
          "
          @mouseover="tooltipLibelle = true"
          @mouseleave="tooltipLibelle = false"
        />
        <span v-if="required" class="text-pink-600 ml-1">*</span>
      </template>
      <template #tooltipLibelleBefore>
        <!-- Display libelle when hover -->
        <transition
          enter-active-class="duration-300 delay-1000"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="tooltipLibelle && libelle != null && libelle != ''"
            class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
          >
            {{ libelle }}
          </div>
        </transition>
      </template>
    </info-bulle>
    <div class="relative">
      <textarea
        :name="name"
        class="bg-white border rounded-md placeholder-gray-600 px-3 py-2 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4 block w-full focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50 appearance-none transition duration-150 ease-in-out text-sm sm:leading-5"
        :rows="size"
        v-model="mutableValue"
        :necessary="progressCount"
        :disabled="disabled || disabled_pass"
        :required="required"
        :maxlength="maxlength"
        :class="{
          'bg-gray-200 cursor-not-allowed': disabled || disabled_pass,
          'border-red-500': error && errorMsg != '',
          'border-indigo-600': !(error && errorMsg != ''),
        }"
        @mouseover="tooltipValue = true"
        @mouseleave="tooltipValue = false"
        @blur="blur()"
      />

      <div
        class="absolute mb-4 right-0 inset-y-0 pt-1 pr-6 flex items-center cursor-pointer"
        v-if="!disabled"
      >
        <SpeechToText
          @result="(result) => updateMutable(result)"
          @startRecognition="startRecognition"
          @stopRecognition="stopRecognition"
        ></SpeechToText>
      </div>

      <!-- Display value when hover -->
      <transition
        enter-active-class="duration-300 delay-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-300"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <!--<div v-if="tooltipValue && mutableValue != null && mutableValue != ''"
          class="absolute rounded-lg shadow-lg bg-white bottom-0 z-30 p-3 text-xs w-max-content w-max max-w-128"
        >
          {{mutableValue}}
        </div> -->
      </transition>
    </div>
    <div v-if="error" class="text-red-500 text-sm">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
import InfoBulle from '../../components/InfoBulle';
import SpeechToText from './SpeechToText.vue';

export default {
  props: {
    name: String,
    libelle: {
      type: String,
      required: false,
      default: '',
    },
    value: String,
    size: [Number, String],
    necessary: Boolean,
    disabled: Boolean,
    error: Boolean,
    msgError: {
      type: String,
      required: false,
      default: '',
    },
    labelLibelle: String,
    inherits: Boolean,
    required: Boolean,
    maxlength: Number,
  },

  components: {
    SpeechToText,
    InfoBulle,
  },
  data: function () {
    return {
      errorMsg: this.msgError,
      mutableValue: this.value,
      valueBeforeSpeech: undefined,
      disabled_pass: false,
      tooltipLabel: false,
      tooltipValue: false,
      tooltipLibelle: false,
      progressCount: true,
      textLibelle: '&nbsp;',
    };
  },
  mounted() {
    // Manage edit permission for neopass pages
    if (this.$route.path.includes('form/neopass')) {
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if (this.$can(page + '_edit', idpass)) {
        this.disabled_pass = false;
      } else {
        this.disabled_pass = true;
      }
    } else {
      this.disabled_pass = false;
    }

    //assign "necessary" prop value to "progressCount" data if this prop is filled
    if (this.necessary != undefined && !this.necessary) {
      this.progressCount = false;
    }

    //assign text to textLibelle if prop Libelle is filled
    if (this.libelle != undefined && this.libelle != null) {
      this.textLibelle = this.libelle;
    }

    if (this.msgError) {
      this.errorMsg = this.msgError;
    }
  },
  methods: {
    startRecognition () {
      this.valueBeforeSpeech = this.mutableValue;
    },

    stopRecognition() {
      this.valueBeforeSpeech = undefined;
    },

    updateMutable(value) {
      this.mutableValue = `${this.valueBeforeSpeech ?? ''} ${value}`;
    },

    displayLabelTooltip(e) {
      if (e.x < (2 * window.outerWidth) / 3) {
        document
          .querySelectorAll(".tooltip-label[name='" + this.name + "']")[0]
          .classList.remove('right-0');
      }

      this.tooltipLabel = !this.tooltipLabel;
    },
    forceHideTooltipLabel(e) {
      if (
        e.target.classList.contains('tooltip-label') &&
        e.target.name == this.name
      ) {
        this.tooltipLabel = !this.tooltipLabel;
      } else {
        if (this.tooltipLabel) this.tooltipLabel = false;
      }
    },

    blur() {
      this.$emit('loseFocus');
    },
  },
  watch: {
    mutableValue() {
      this.$emit('input', this.mutableValue);

      if (
        this.maxlength &&
        this.mutableValue &&
        this.mutableValue.length >= this.maxlength
      ) {
        this.errorMsg =
          'Vous avez atteint la taille maximum de ' +
          this.maxlength +
          ' caractères.';
      } else if (
        this.maxlength &&
        this.mutableValue &&
        this.mutableValue.length < this.maxlength
      ) {
        this.errorMsg = '';
      } else if (this.msgError) {
        this.errorMsg = this.msgError;
      } else {
        this.errorMsg = '';
      }
    },

    value() {
      this.mutableValue = this.value;
    },

    msgError() {
      this.errorMsg = this.msgError;
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
};
</script>
